import { cloneDeep } from "lodash";
import { checklistStatusId } from "./constants";

export const getDataToChart = (data, dateField, valueField, numTickX = 12) => {
  let tickX;
  let latestHistoryIdx = 0;
  const mainTicks = {},
    monthArr: any = [],
    valueArrays: any = [];
  // If only one data point
  if (data.length === 1) {
    const tickDataPoint = Math.ceil(numTickX / 2);
    const numTickAfter = numTickX - tickDataPoint;
    const numTickBefore = numTickX - 1 - numTickAfter;
    const dataPointData = new Date(data[0][dateField]);
    const currentDate = new Date(data[0][dateField]);
    // pass data for before data point
    for (let i = numTickBefore; i > 0; i--) {
      currentDate.setMonth(currentDate.getMonth() - 1);
      mainTicks[`${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`] =
        true;
      monthArr.push(
        `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`,
      );
      valueArrays.push(-1);
    }
    monthArr.reverse();
    // pass data for only data point
    monthArr.push(
      `${dataPointData.getMonth() + 1}-${dataPointData.getFullYear()}`,
    );
    valueArrays.push(data[0][valueField]);
    mainTicks[
      `${dataPointData.getMonth() + 1}-${dataPointData.getFullYear()}`
    ] = true;
    if (data[0].isLatestHistory) latestHistoryIdx = numTickBefore;

    // pass data for after data point
    const currentDateAfter = new Date(data[0][dateField]);
    for (let i = 0; i < numTickAfter; i++) {
      currentDateAfter.setMonth(currentDateAfter.getMonth() + 1);
      mainTicks[
        `${currentDateAfter.getMonth() + 1}-${currentDateAfter.getFullYear()}`
      ] = true;
      monthArr.push(
        `${currentDateAfter.getMonth() + 1}-${currentDateAfter.getFullYear()}`,
      );
      valueArrays.push(-1);
    }
  } else {
    // find min and max month
    const dates = data.map((item) => new Date(item[dateField]));
    const minDate = new Date(Math.min(...dates));
    const maxDate = new Date(Math.max(...dates));
    // find boundary month
    const yearsDifference = maxDate.getFullYear() - minDate.getFullYear();
    const monthsDifference = maxDate.getMonth() - minDate.getMonth();
    const totalMonths = yearsDifference * 12 + monthsDifference;
    if (totalMonths > numTickX) {
      tickX = Math.ceil(totalMonths / (numTickX - 1));
      const startDate = cloneDeep(minDate);
      const totalMonthsTicks = tickX * (numTickX - 1);
      const distance = totalMonthsTicks - totalMonths;
      if (distance > 0 && distance / 2 >= tickX) {
        const subTikcs = Math.floor(distance / (tickX * 2));
        startDate.setMonth(startDate.getMonth() - subTikcs * tickX);
      }
      const endDate = cloneDeep(startDate);
      endDate.setMonth(startDate.getMonth() + totalMonthsTicks);

      // create main ticksX is numTickX points in Xaxis
      const currentDate = new Date(startDate);
      for (let i = 0; i < numTickX; i++) {
        mainTicks[
          `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`
        ] = true;
        currentDate.setMonth(currentDate.getMonth() + tickX);
      }
      // create ticks for each month
      let index = 0;
      while (startDate <= endDate) {
        const monthYear = `${
          startDate.getMonth() + 1
        }-${startDate.getFullYear()}`;
        const scoreObj = data.find((item) => {
          const itemDate = new Date(item[dateField]);
          return (
            itemDate.getMonth() === startDate.getMonth() &&
            itemDate.getFullYear() === startDate.getFullYear()
          );
        });
        if (scoreObj?.isLatestHistory) latestHistoryIdx = index;
        monthArr.push(monthYear);
        valueArrays.push(
          scoreObj
            ? scoreObj[valueField]
            : startDate <= minDate || startDate >= maxDate
              ? -1
              : null,
        );
        startDate.setMonth(startDate.getMonth() + 1);
        index++;
      }
    } else {
      // if total month is less than numTickX
      const midStartIndex = Math.floor((numTickX - totalMonths - 1) / 2);
      const midEndIndex = numTickX - midStartIndex - totalMonths - 1;
      // pass data for before data point
      const currentDate = new Date(minDate);
      const originalDay = currentDate.getDate();
      currentDate.setMonth(currentDate.getMonth() - 1);
      if (currentDate.getDate() !== originalDay) {
        currentDate.setDate(0);
      }
      for (let i = 0; i < midStartIndex; i++) {
        mainTicks[
          `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`
        ] = true;
        monthArr.push(
          `${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`,
        );
        valueArrays.push(-1);
        currentDate.setMonth(currentDate.getMonth() - 1);
      }
      monthArr.reverse();
      // pass data for data point
      const currentDateDataPoint = new Date(minDate);
      for (let i = 0; i <= totalMonths; i++) {
        const monthYear = `${
          currentDateDataPoint.getMonth() + 1
        }-${currentDateDataPoint.getFullYear()}`;
        const scoreObj = data.find((item) => {
          const itemDate = new Date(item[dateField]);
          return (
            itemDate.getMonth() === currentDateDataPoint.getMonth() &&
            itemDate.getFullYear() === currentDateDataPoint.getFullYear()
          );
        });
        if (scoreObj?.isLatestHistory) latestHistoryIdx = i + midStartIndex;
        mainTicks[monthYear] = true;
        monthArr.push(monthYear);
        valueArrays.push(scoreObj ? scoreObj[valueField] : null);
        const originalDay = currentDateDataPoint.getDate();
        currentDateDataPoint.setMonth(currentDateDataPoint.getMonth() + 1);
        if (currentDateDataPoint.getDate() !== originalDay) {
          currentDateDataPoint.setDate(0);
        }
      }
      // pass data for after data point
      const currentDateAfter = new Date(maxDate);
      for (let i = 0; i < midEndIndex; i++) {
        const originalDay = currentDateAfter.getDate();
        currentDateAfter.setMonth(currentDateAfter.getMonth() + 1);
        if (currentDateAfter.getDate() !== originalDay) {
          currentDateAfter.setDate(0);
        }
        mainTicks[
          `${currentDateAfter.getMonth() + 1}-${currentDateAfter.getFullYear()}`
        ] = true;
        monthArr.push(
          `${
            currentDateAfter.getMonth() + 1
          }-${currentDateAfter.getFullYear()}`,
        );
        valueArrays.push(-1);
      }
    }
  }

  return { mainTicks, monthArr, valueArrays, latestHistoryIdx };
};

export const getColorGradients = (value, min, max, isIssue = false) => {
  const fiftyPercentile = (min + max) * 0.5;
  let startColor, endColor;
  if (!isIssue) {
    if (value < fiftyPercentile) {
      startColor = [247, 0, 0];
      endColor = [255, 163, 0];
    } else {
      startColor = [255, 163, 0];
      endColor = [1, 137, 61];
    }
  }
  if (isIssue) {
    if (value < fiftyPercentile) {
      startColor = [1, 137, 61];
      endColor = [255, 163, 0];
    } else {
      startColor = [255, 163, 0];
      endColor = [247, 0, 0];
    }
  }
  // Recalculate the value
  let newValue;
  if (value >= fiftyPercentile) {
    newValue = (value - fiftyPercentile) / (fiftyPercentile - min);
  } else {
    newValue = (value - min) / (fiftyPercentile - min);
  }
  const finalColor: any = [];
  for (let i = 0; i < 3; i++) {
    finalColor[i] = Math.round(
      startColor[i] + (endColor[i] - startColor[i]) * newValue,
    );
  }

  if (!Number(newValue) || newValue === -Infinity || newValue === Infinity) {
    finalColor[0] = startColor[0];
    finalColor[1] = startColor[1];
    finalColor[2] = startColor[2];
  }

  // return the color in rgba format to hex
  const hexColor = finalColor.map((item) => {
    const hex = item.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  });
  return "#" + hexColor[0] + hexColor[1] + hexColor[2];
};

export const getMarkers = (
  arrayValueWithNull,
  arrayValueWithoutNull,
  isIssue = false,
  seriesIndex = 0,
  useMaxColorRange = false,
  checklistsWithMetrics: any[] = [],
) => {
  const arrayWithRealData = arrayValueWithNull.filter(
    (item) => item !== null && item !== -1,
  );
  let min, max;
  if (useMaxColorRange) {
    min = 0;
    max = 1;
  } else {
    min = Math.min(...arrayWithRealData);
    max = Math.max(...arrayWithRealData);
  }
  const arrayCHecklistHasValue = arrayValueWithNull
    .map((item, index) => {
      return {
        data: item,
        index: index,
      };
    })
    .filter((item) => item.data !== null && item.data !== -1);
  const checklistDatas = checklistsWithMetrics.reverse();
  const markers = arrayValueWithoutNull.map((item, index) => {
    const indexMetric = arrayCHecklistHasValue.findIndex(
      (metric) => metric.index === index,
    );
    const checklistData = indexMetric !== -1 ? checklistDatas[indexMetric] : {};

    return {
      seriesIndex,
      dataPointIndex: index,
      fillColor:
        checklistData?.checklistStatusId === checklistStatusId.inProgress
          ? "#b7b7b7"
          : "#FFF",
      strokeColor:
        checklistData?.checklistStatusId === checklistStatusId.inProgress
          ? "#b7b7b7"
          : arrayWithRealData.length > 1
            ? getColorGradients(item, min, max, isIssue)
            : getBaseColor(item, isIssue),
      size:
        arrayValueWithNull[index] === null || arrayValueWithNull[index] === -1
          ? 0
          : 6,
      shape: "circle",
    };
  });
  return markers;
};

export const getBaseColor = (value, isIssue) => {
  if (value < 30) {
    if (isIssue) {
      return "#01893D";
    }
    return "#F70000";
  }
  if (value < 66) {
    return "#FFA300";
  }
  if (isIssue) {
    return "#F70000";
  }
  return "#01893D";
};

export const connectNulls = (arr, replaceNull = false) => {
  if (arr[0] === null) arr[0] = 0;
  for (let i = 1; i < arr.length - 1; i++) {
    if (arr[i] === null) {
      const left = arr[i - 1];
      let j = i + 1;
      // Find the next non-null value on the right
      while (j < arr.length && arr[j] === null) {
        j++;
      }

      const right = arr[j] !== undefined ? arr[j] : left;

      // Replace the null value with the average of left and right
      arr[i] = Number((right - left) / (j - i + 1)) + Number(left);
    }
  }
  // replace value -1 to null
  return [
    {
      name: "Mock Data",
      data: !replaceNull ? arr : arr.map((item) => (item === -1 ? null : item)),
    },
  ];
};

export const removeDuplicateMonthYear = (records, dateField) => {
  const map = new Map();

  records.forEach((record) => {
    const [year, month, day] = record[dateField].split("-");
    const monthYearKey = `${year}-${month}`;

    if (!map.has(monthYearKey)) {
      map.set(monthYearKey, record);
    } else {
      const existingRecord = map.get(monthYearKey);
      if (parseInt(day) > parseInt(existingRecord[dateField].split("-")[2])) {
        map.set(monthYearKey, record);
      }
    }
  });

  return Array.from(map.values());
};
